import { render, staticRenderFns } from "./ModalSellerOrSplitter.vue?vue&type=template&id=e682e5ea"
import script from "./ModalSellerOrSplitter.vue?vue&type=script&lang=js"
export * from "./ModalSellerOrSplitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports